import type { ObjectId } from '@racemap/sdk/schema/base';
import type { StripePriceWithTax } from '@racemap/sdk/schema/billing';
import type { StripeProducts } from '@racemap/sdk/schema/billing/StripeProducts';
import { RacemapAPIClient } from '@racemap/utilities/api-client';
import { OneMinuteInMillis } from '@racemap/utilities/consts/time';
import useSWR from 'swr';

const apiClient = RacemapAPIClient.fromWindowLocation();
export type PriceList = Record<StripeProducts, StripePriceWithTax>;

export function usePriceList({
  userId,
  isReseller,
}: { userId?: ObjectId | string; isReseller?: boolean } = {}): {
  priceList: PriceList | undefined;
  isReseller: boolean | undefined;
  isLoading: boolean;
  error: Error;
} {
  // if userId is defined, we fetch the price list for that user, otherwise we check if isReseller is defined,
  // if not we fetch the price list for a non reseller user
  const { data, isLoading, error } = useSWR(
    ['GET_PRICE_LIST', userId, isReseller],
    async ([, userId, isReseller]) => {
      return await apiClient.getPriceList({ userId, isReseller });
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      refreshInterval: OneMinuteInMillis * 30,
      keepPreviousData: true,
    },
  );
  const priceList = data?.list;

  return {
    priceList,
    isReseller: data?.isReseller,
    isLoading,
    error,
  };
}
